import { render, staticRenderFns } from "./TypeRegulationForm.vue?vue&type=template&id=5f3b87ae&"
import script from "./TypeRegulationForm.vue?vue&type=script&lang=js&"
export * from "./TypeRegulationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports